import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

export const languages = ["en", "zh"];

const defaultLng = "en";

(i18next as any)
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: defaultLng,
    fallbackLng: "en", // use et if detected lng is not available
    saveMissing: true, // send not translated keys to endpoint
    debug: false,
    whitelist: languages,
    react: {
      useSuspense: false,
    },
  });

export default i18next;
